module.exports = __webpack_public_path__ + "static/media/ajit.47bb7246.png";